import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { QuestionIcon } from "@phosphor-icons/react";

import { renderValue } from "utils/renderCompanyCell";

import Icon from "components/Icon/Icon";
import CommonTooltip from "components/Tooltip/index";
import RowActionsMenu from "../RowActionsMenu";
import { TYPE_STYLES } from "../data";

const columnHelper = createColumnHelper();

const ManagerColumns = ({ onEdit, onRemove }) => {
  return [
    columnHelper.accessor("id", {
      header: "Id",
      size: 96,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => renderValue(info.getValue())
    }),

    columnHelper.accessor("name", {
      header: "Member Name",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => renderValue(info.getValue())
    }),

    columnHelper.accessor("role", {
      header: () => (
        <div className="header-content">
          <span>Access Level</span>
          <CommonTooltip
            tooltipContent="All team members get access to Signal. Admins can additionally manage users and settings."
            theme="dark"
            className="creator-manager-content"
          >
            <Icon
              component={QuestionIcon}
              size={12}
              className="header-info-icon"
            />
          </CommonTooltip>
        </div>
      ),
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => {
        let type = info.getValue();

        // Force all non-admin values to "standard"
        if (type !== "admin") type = "standard";

        const styles = TYPE_STYLES[type] || {};

        return (
          <span
            className="type-badge"
            style={{
              color: styles.color,
              border: `1px solid ${styles.borderColor}`,
              backgroundColor: styles.backgroundColor
            }}
          >
            {renderValue(type?.replace("_", " "))}
          </span>
        );
      }
    }),

    columnHelper.accessor("creator_manager", {
      header: () => (
        <div className="header-content">
          <span>Creator Manager?</span>
          <CommonTooltip
            tooltipContent="Only Creator Managers can be assigned creators and are visible as managers on the HashFame app."
            theme="dark"
            className="creator-manager-content"
          >
            <Icon
              component={QuestionIcon}
              size={12}
              className="header-info-icon"
            />
          </CommonTooltip>
        </div>
      ),
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell creator-cell",
      enableSorting: false,
      cell: (info) => {
        const type = info.getValue();
        const styles = TYPE_STYLES[type] || {};

        return (
          <span
            className="type-badge"
            style={{
              color: styles.color,
              border: `1px solid ${styles.borderColor}`,
              backgroundColor: styles.backgroundColor
            }}
          >
            {renderValue(type)}
          </span>
        );
      }
    }),

    columnHelper.accessor("creators_managed", {
      header: "Creators Managed",
      size: 160,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      enableSorting: false,
      cell: (info) => renderValue(info.getValue())
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 240,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => renderValue(info.getValue())
    }),

    columnHelper.accessor("phone_number", {
      header: "Phone",
      size: 160,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => renderValue(info.getValue())
    }),

    columnHelper.display({
      id: "actions",
      header: "Actions",
      size: 92,
      headerClassName: "table-header mono",
      cellClassName: "table-cell mono",
      cell: ({ row }) => {
        const rowData = row.original;

        return (
          <RowActionsMenu
            onEdit={() => onEdit(rowData)}
            onRemove={() => onRemove(rowData)}
          />
        );
      }
    })
  ];
};

export default ManagerColumns;
